import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderService } from '../../services/loader.service';
import { HelpService } from '../../services/help.service';

@Component({
  selector: 'app-foreign-check',
  imports: [],
  templateUrl: './foreign-check.component.html',
  styleUrl: './foreign-check.component.css'
})
export class ForeignCheckComponent implements OnInit{

  error:string = 'No es posible continuar con tu vinculación por este medio, por favor acércate a una oficina.'
  url:any;
  phone: string;

  constructor(
    private sanitizer: DomSanitizer,
    private _loaderService: LoaderService,
    private _helpService: HelpService
    ) {
      this.phone = localStorage.getItem('phone') ?? '';
  }

  ngOnInit(): void {
    this._helpService.show();
    const greating = `Hola, necesito tu ayuda para continuar con mi vinculación digital.`;
    const errorMessage = `Me sale el error: ${ this.error }. Gracias`;
    const consolidateErrorMessage = encodeURIComponent(`${greating}${errorMessage}`);
    this.url = this.sanitizer.bypassSecurityTrustUrl(`https://api.whatsapp.com/send?phone=+57${this.phone}&text=${consolidateErrorMessage}`);
    this._loaderService.hide();

  }

}
